import { StrictMode } from 'react'
import type { VFC } from 'react'
import { Theme, Spacing } from '@opallabs/gem'
import { Radio, ParagraphText, StrongText } from '@opallabs/lapidary'
import * as styles from '../styles'
import type { SidebarProps } from '../types'

export type Props = Pick<SidebarProps, 'theme'> &
  Readonly<{
    contentUpdating: boolean
    onChange: (isVisible: boolean) => void
  }>

export const ContentUpdatingSection: VFC<Props> = ({
  contentUpdating,
  onChange,
  theme = 'light',
}) => {
  return (
    <StrictMode>
      <ParagraphText
        styleOverrides={{ marginInlineEnd: Spacing.S }}
        theme={theme}
      >
        <StrongText styleOverrides={{ fontSize: 14 }}>
          Automatic Content Updating
        </StrongText>
      </ParagraphText>

      <ParagraphText
        styleOverrides={{ marginInlineEnd: Spacing.S }}
        theme={theme}
      >
        Keep your slide automatically up-to-date with the latest content
        changes.
      </ParagraphText>

      <div css={styles.field(theme as Theme)}>
        <Radio.Group
          defaultValue={contentUpdating.toString()}
          name="Slide Content Updating"
          onChange={(e) => onChange(e.target.value === 'true')}
          theme={theme as Theme}
        >
          <Radio.Input label="Update" value="true" />
          <Radio.Input label="Don't update" value="false" />
        </Radio.Group>
      </div>
    </StrictMode>
  )
}
ContentUpdatingSection.displayName =
  'Hubble: ContentUpdatingSection ← Sidebar ← SlideEditor'
